import styled, { css } from 'styled-components';

export const Container = styled.div`
    width: 100%;
    height: 8px;
    overflow: hidden;
    background-color: ${({ theme }) => theme.colors.secondaryBackground};
`;

export const Bar = styled.div`
    height: 100%;
    transition-duration: 0.8s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

    ${({ width }) => css`
        background-color: #666666;
        width: ${width}%;
        transition-property: ${width};
        border-radius: ${width < 100 ? '0 8px 8px 0' : '0'};
    `}
`;
